import useTitanApp from "../../../hooks/useTitanApp";
import {
    deletePatientConditionRelated,
    setCurrentPatientConditionRelatedToDelete,
    getPatientConditionRelated,
} from "../../../dispatchers/patientDispatchers";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import "../../../assets/css/PatientDeleteConditionRelatedModal.scss";

export default function PatientDeleteConditionRelatedModal() {
    const { appState, patientState } = useTitanApp();
    const { darkMode } = appState || {};
    const {
        selectedPatientDetails,
        showDeleteConditionRelatedModal,
        deletePatientConditionRelatedLoader,
        selectedPatientConditionRelated,
        consultationId
    } = patientState || {};

    const closeModal = () => {
        setCurrentPatientConditionRelatedToDelete(null);
    };

    const handleDeleteClick = async () => {
        if (!selectedPatientConditionRelated) return;

        try {
            let lstConditionsRelated = [];
            const conditionRelated = {
                conditionName: selectedPatientConditionRelated?.conditionName,
                status: selectedPatientConditionRelated?.Status === "" ? null : Number(selectedPatientConditionRelated?.status),
                diagnosedDate: selectedPatientConditionRelated?.typicalReaction,
                additionalNotes: selectedPatientConditionRelated?.additionalNotes,
            };
            lstConditionsRelated.push(conditionRelated);
            const patientConditionRelated = {
                consultationId,
                patientId: selectedPatientDetails?.patientID,
                relatedConditions: lstConditionsRelated,
            };
            await deletePatientConditionRelated(patientConditionRelated)
            await getPatientConditionRelated(selectedPatientDetails?.patientID);
            closeModal();
            setCurrentPatientConditionRelatedToDelete(null);
        } catch (error) {
            console.error("Error in deleting patient condition-related:", error);
        }
    };
    return (
        <Modal
            show={showDeleteConditionRelatedModal}
            onHide={closeModal}
            centered
            backdrop="static"
            dialogClassName="pc-modal-delete-condition-related delete-condition-related"
            size="md"
        >
            <div className="header">
                <div className="info">
                    <div className="icon-box">
                        <div className="dot"></div>
                    </div>
                    <p className="label">
                        Delete Medical Condition
                    </p>
                </div>
                <IoClose
                    size={20}
                    color={darkMode ? "#bdbdbd" : "#7c7c7c"}
                    onClick={closeModal}
                />
            </div>
            <div className="body">
                <div>
                    <p>
                        Are you sure you want to delete the medical condition {selectedPatientConditionRelated ? `"${selectedPatientConditionRelated?.conditionName}"` : "this"}? Do you want to continue?
                    </p>
                </div>
                <div className="pc-delete-condition-related-footer-actions">
                    <button className="cancel" type="button" onClick={closeModal}>
                        Cancel
                    </button>
                    <button
                        className="done"
                        type="submit"
                        disabled={deletePatientConditionRelatedLoader}
                        onClick={() => handleDeleteClick()}
                    >
                        {deletePatientConditionRelatedLoader === true ? "Deleting Condition..." : "Delete Condition"}
                    </button>
                </div>
            </div>
        </Modal>
    );
};
